import React, { useRef } from 'react';

import ModalPhotoBase from './ModalPhotoBase';

import PhotoBg from '../../../../../Images/modals/photographers/erick/bg_erick.png';
import Photo1 from '../../../../../Images/modals/photographers/erick/photo-1.png';
import Photo2 from '../../../../../Images/modals/photographers/erick/photo-2.png';

import {
  Photo_Erick,
  Text_Erick,
  TextPhoto1_Erick,
  TextPhoto2_Erick,
} from '../../../../../utils/EN/Modals/photographers';

const ModalErick = () => {
  return (
    <>
      <ModalPhotoBase
        id="photo-erick"
        mainBg={PhotoBg}
        directorName={Photo_Erick}
        mainVideoBg={Photo1}
        videoText1={TextPhoto1_Erick}
        directorText={Text_Erick}
        rowImage1={Photo2}
        videoText2={TextPhoto2_Erick}
        rowWidth1={'728px'}
        rowWidth2={'0px'}
        rowWidth3={'0px'}
        mainGallery={'erick-gallery-1'}
        gallery2={'erick-gallery-2'}
      />
    </>
  );
};

export default ModalErick;
